// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonActions } from "./common-actions";
import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";
import { environmentCommonFields } from "./environment-common-fields";
import { environmentCommonObjects } from "./environment-common-objects";
import { environmentCommonValues } from "./environment-common-values";

export const environmentTopologyVersions = {
  title: "トポロジバージョン",
  subtitle: "トポロジテンプレートの凍結スナップショット、公開対象、および血縁情報を扱います。",
  summaryTotal: "総数",
  summaryPublished: environmentCommonValues.status.published,
  summaryDraft: environmentCommonValues.status.draft,
  summaryArchived: environmentCommonValues.status.archived,
  summaryShared: environmentCommonValues.visibility.shared,
  columns: {
    code: commonShortFieldLabels.code,
    name: "トポロジバージョン",
    imageIdentifier: "バージョン識別子",
    imageTitle: "バージョン名",
    status: commonShortNouns.status,
    shareMode: environmentCommonFields.shareMode,
    versionNo: "バージョン",
    nodeCount: "ノード数",
    networkCount: "ネットワーク数",
    accessPointCount: "接入点数",
    roleCount: "ロール数",
    derivationType: "派生種別",
    tags: environmentCommonFields.tags,
    description: environmentCommonFields.description,
    createdAt: commonShortFieldLabels.createdAt,
    actions: commonShortNouns.actions,
  },
  actions: {
    refresh: commonActions.refresh,
    viewDetail: "詳細",
    share: commonActions.share,
  },
  forms: {
    topologyTemplate: environmentCommonObjects.topologyTemplate,
    displayName: environmentCommonFields.displayName,
    description: commonShortFieldLabels.description,
    tags: environmentCommonFields.tags,
    tagsPlaceholder: "カンマ区切り。例: published, web",
    requiredTopologyTemplate: "トポロジテンプレートを選択してください",
    requiredStatus: "状態を選択してください",
    requiredShareMode: "共有方式を選択してください",
  },
  scopes: {
    mine: "自分のもの",
    shared_with_me: "共有されたもの",
    public: "公開",
    all: "すべて",
  },
  shareMode: {
    private: environmentCommonValues.visibility.private,
    shared_to_users: "個別共有",
    public: "公共",
  },
  share: {
    title: "トポロジバージョンを共有",
    notice:
      "共有設定はトポロジバージョン編集から分離されています。編集ドロワーはバージョンのメタデータのみを扱い、共有関係はここで管理します。",
    publicDescription:
      "公共区に共有すると、このプラットフォーム入口の読み取り権限を持つすべてのユーザーがこのトポロジバージョンを閲覧できます。",
    selectedUsersTitle: "共有ユーザー",
    emptyUsers: "個別共有ユーザーはまだありません",
    actions: {
      pickUsers: "組織からユーザーを選択",
    },
    fields: {
      capabilities: "付与する能力",
    },
    capabilities: {
      view: "表示",
      reference: "参照",
      clone: "クローン",
    },
    errors: {
      selectAtLeastOneUser: "共有するユーザーを少なくとも1人選択してください",
      selectCapabilities: "少なくとも1つの能力を選択してください",
    },
    messages: {
      saveSuccess: "トポロジバージョンの共有設定を保存しました",
      saveFailed: "トポロジバージョンの共有設定の保存に失敗しました",
    },
  },
  drawers: {
    topologyViewSnapshot: environmentCommonObjects.topologyViewSnapshot,
  },
  preview: {
    title: "トポロジプレビュー",
    ariaLabel: "トポロジバージョンのビュースナップショットプレビュー",
    empty: "このバージョンにはプレビュー可能な X6 ビュースナップショットがまだありません。",
    readonlyDescription:
      "ここでは現在のトポロジバージョンに凍結された X6 ビュースナップショットを読み取り専用で表示し、編集はできません。",
  },
  status: {
    published: environmentCommonValues.status.published,
  },
  errors: {
    loadFailed: "トポロジバージョンの読み込みに失敗しました",
  },
} as const;
